import React, { Fragment } from 'react';
import { useParams } from 'react-router-dom'
import blogs from '../../api/blogs'
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import BlogSingle from '../../components/BlogDetails/BlogSingle.js'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import logo from '../../images/Horizontal-Logo-white.png';
import SEO from '../../components/SEO/SEO';

const BlogDetailsFull = () => {
    const { slug } = useParams()

    const BlogDetails = blogs.find(item => item.slug === slug)
    const metaTitle = BlogDetails ? BlogDetails.title : 'Article';
    const metaDescription = BlogDetails ? (BlogDetails.description || BlogDetails.detailDescription?.slice(0, 160)) : undefined;
    // Use the primary site domain for canonical URLs to avoid duplicate content issues
    const SITE_URL = 'https://pharmacyfreedomfund.com';
    const canonical = `${SITE_URL}/newsroom/${slug}`;

    // JSON-LD: Breadcrumbs + BlogPosting (prefer PNG/JPG for social crawlers)
    const imageUrl = `${SITE_URL}/Logo-freedom-color-white-bg.png`;
    const dateISO = BlogDetails?.create_at ? new Date(BlogDetails.create_at).toISOString() : undefined;
    const schema = BlogDetails ? [
        {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
                { '@type': 'ListItem', position: 1, name: 'Home', item: `${SITE_URL}/` },
                { '@type': 'ListItem', position: 2, name: 'Newsroom', item: `${SITE_URL}/newsroom` },
                { '@type': 'ListItem', position: 3, name: BlogDetails.title, item: canonical },
            ],
        },
        {
            '@context': 'https://schema.org',
            '@type': 'BlogPosting',
            headline: BlogDetails.title,
            alternativeHeadline: BlogDetails.title2,
            description: metaDescription,
            image: [imageUrl],
            author: { '@type': 'Organization', name: 'Pharmacy Freedom Fund' },
            publisher: {
                '@type': 'Organization',
                name: 'Pharmacy Freedom Fund',
                logo: { '@type': 'ImageObject', url: `${SITE_URL}/Logo-freedom-color-white-bg.png` },
            },
            mainEntityOfPage: { '@type': 'WebPage', '@id': canonical },
            datePublished: dateISO,
            dateModified: dateISO,
            keywords: BlogDetails.tag,
            articleSection: 'Newsroom',
            url: canonical,
        },
    ] : undefined;
    return (
        <Fragment>
            <SEO
                title={metaTitle}
                description={metaDescription}
                keywords={[BlogDetails?.tag, 'pharmacy investing', 'independent pharmacy']}
                canonical={canonical}
                type="article"
                schema={schema}
            />
            <Navbar Logo={logo} hclass={'wpo-site-header wpo-site-header-s2'} />
            <PageTitle pageTitle={BlogDetails.title} pagesub={'Newsroom'} />
            <BlogSingle blLeft={'d-none'} blRight={'col-lg-10 offset-lg-1'} />
            <Footer hclass={'wpo-site-footer_s2'} />
            <Scrollbar />
        </Fragment>
    )
};
export default BlogDetailsFull;